// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { FcmSendData, FcmSendEachData, FcmSendMulticastData, FcmTopicSubData } from '@res/ng-shared';
import { MessagePayload } from 'firebase/messaging';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FCMActions {
  export class GetAllFCM {
    static readonly type = '[FCM] GetAllFCM';
    readonly type = GetAllFCM.type;
  }

  export class InitFCMs {
    static readonly type = '[FCM] InitFCMs';
    constructor(public id?: string) {}
  }

  export class SubscribeToFCMsTopic {
    static readonly type = '[FCM] SubscribeToFCMsTopic';
    constructor(public topicSubData: FcmTopicSubData) {}
  }

  export class UnSubscribeToFCMsTopic {
    static readonly type = '[FCM] UnSubscribeToFCMsTopic';
    constructor(public topic: FcmTopicSubData) {}
  }

  export class SendToFCMs {
    static readonly type = '[FCM] SendToFCMs';
    constructor(public topic: FcmSendData) {}
  }

  export class SendEachToFCMs {
    static readonly type = '[FCM] SendEachToFCMs';
    constructor(public topic: FcmSendEachData) {}
  }

  export class SendEachForMulticastToFCMs {
    static readonly type = '[FCM] SendEachForMulticastToFCMs';
    constructor(public topic: FcmSendMulticastData) {}
  }

  export class StartFCMs {
    static readonly type = '[FCM] StartFCMs';
    readonly type = StartFCMs.type;
  }

  export class NewFCMs {
    static readonly type = '[FCM] NewFCMs';
    constructor(public fcmData: MessagePayload) {}
  }

  export class GetFCMById {
    static readonly type = '[FCM] GetFCMById';
    readonly type = GetFCMById.type;
  }

  export class UpdateFCM {
    static readonly type = '[FCM] UpdateFCM';
    constructor(
      public fcmData: string,
      public ref: string,
    ) {}
  }

  export class DeleteFCM {
    static readonly type = '[FCM] DeleteFCM';
    readonly type = DeleteFCM.type;
  }

  export class FCMError {
    static readonly type = '[FCM] FCMError';

    constructor(public error: Error) {}
  }
}
